<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title>Reject Email</v-card-title>
      <v-card-text>
        <p>This will mark the related task Off-Track for manual follow-up. There is no auto-retry.</p>
        <v-textarea
          v-model="rejectionReason"
          label="Rejection Reason (optional)"
          outlined
          rows="3"
          autofocus
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('close')">Cancel</v-btn>
        <v-btn color="error" @click="$emit('reject', rejectionReason)">Reject</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      dialog: true,
      rejectionReason: null
    }
  }
}
</script>
